import { render, staticRenderFns } from "./AjaxErrorWarning.vue?vue&type=template&id=0c598e99&scoped=true&"
import script from "./AjaxErrorWarning.vue?vue&type=script&lang=js&"
export * from "./AjaxErrorWarning.vue?vue&type=script&lang=js&"
import style0 from "./AjaxErrorWarning.vue?vue&type=style&index=0&id=0c598e99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c598e99",
  null
  
)

export default component.exports